(function () {
    const SELECTORS = {
        // scope root = the same component root that emits the event
        root: "[data-mb-hero-info]",

        // price UI
        priceCurrent: "[data-mb-price-current]",
        priceComparisonWrap: "[data-mb-price-comparison]",
        priceOriginal: "[data-mb-price-original]",
        priceSaved: "[data-mb-price-saved]",
        cartCurrency: "[data-mb-cart-currency]",
        freeShipping: "[data-mb-free-shipping]",
        moneyFormatEl: "[data-mb-money-format]",
    };

    // --- Boot ---
    function init(scope = document) {
        scope.querySelectorAll(SELECTORS.root).forEach((root) => {
            if (root.dataset.mbHeroInfoInit === "true") return;
            root.dataset.mbHeroInfoInit = "true";

            document.addEventListener("mb:variant:change", (e) => {
                const variant = e.detail?.variant;
                const variantId = e.detail?.variantId;

                if (!variant || !variantId) return;

                onVariantChange(root, variant, variantId);
            });
        });
    }

    function onVariantChange(root, variant, variantId) {
        const moneyFormat = getMoneyFormat();

        updateVariantUrl(variantId);
        updateCurrentPrice(root, variant, moneyFormat);
        updateCompareAndSavings(root, variant, moneyFormat);
        updateFreeShipping(root, variant, moneyFormat);
        updateInstallments(variant, moneyFormat)
    }


    // --- Small functions (single responsibility) ---

    function getMoneyFormat() {
        // Optional: add an element somewhere:
        // <script type="application/json" data-mb-money-format>{{ shop.money_format | json }}</script>
        const el = document.querySelector(SELECTORS.moneyFormatEl);
        const raw = el?.textContent?.trim();

        // If you store JSON string, parse it:
        if (raw && raw.startsWith('"')) {
            try {
                return JSON.parse(raw);
            } catch (_) { }
        }

        return raw || "{{amount}}";
    }

    function updateCurrentPrice(root, variant, moneyFormat) {
        const el = root.querySelector(SELECTORS.priceCurrent);
        if (!el) return;
        const price = toNumberOrZero(variant.price);
        el.textContent = formatMoney(price, moneyFormat);
    }

    function updateCompareAndSavings(root, variant, moneyFormat) {
        const wrap = root.querySelector(SELECTORS.priceComparisonWrap);
        const originalEl = root.querySelector(SELECTORS.priceOriginal);
        const savedEl = root.querySelector(SELECTORS.priceSaved);

        if (!wrap && !originalEl && !savedEl) return;

        const price = toNumberOrZero(variant.price);
        const compare = toNumberOrNull(variant.compare_at_price);

        const hasSaving = typeof compare === "number" && compare > price;

        if (wrap) wrap.style.display = hasSaving ? "" : "none";

        if (!hasSaving) {
            if (originalEl) originalEl.textContent = "";
            if (savedEl) savedEl.textContent = "";
            return;
        }

        if (originalEl) originalEl.textContent = formatMoney(compare, moneyFormat);
        if (savedEl) savedEl.textContent = formatMoney(compare - price, moneyFormat);
    }

    function updateVariantUrl(variantId) {
        try {
            const url = new URL(window.location.href);
            url.searchParams.set("variant", String(variantId));
            window.history.replaceState({}, "", url.toString());
        } catch (_) { }
    }

    function updateInstallments(variant, moneyFormat) {
        const el = document.querySelector("[data-installment-price]");
        if (!el) return;
        const price = toNumberOrZero(variant.price) / 3;
        el.textContent = formatMoney(price, moneyFormat);
    }

    // Optional: define your rule and enable call in onVariantChange()
    function updateFreeShipping(root, variant, moneyFormat) {
        const el = root.querySelector(SELECTORS.freeShipping);
        if (!el) return;
        const currency = getCurrency()

        const rates = {
            "RON": 5
        }

        const rate = rates[currency] || 1;
        const price = toNumberOrZero(variant.price) / rate
        const show = price >= 30000;
        el.style.display = show ? "" : "none";
    }

    // --- Helpers (small + reusable) ---
    function getCurrency() {
        const el = document.querySelector(SELECTORS.cartCurrency)?.textContent;
        if (!el) return
        const currency = el.replace(/"/g, "").trim();
        return currency;
    }

    function toNumberOrZero(val) {
        const n = Number(val);
        return Number.isFinite(n) ? n : 0;
    }

    function toNumberOrNull(val) {
        const n = Number(val);
        return Number.isFinite(n) ? n : null;
    }

    function formatMoney(cents, moneyFormat) {
        const value = toNumberOrZero(cents);

        const formatWithDelimiters = (amount, precision, thousands, decimal) => {
            const number = (amount / 100).toFixed(precision);
            const [intPartRaw, decPart] = number.split(".");
            const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return precision > 0 ? `${intPart}${decimal}${decPart}` : intPart;
        };

        const tokenMap = {
            amount: () => formatWithDelimiters(value, 2, ",", "."),
            amount_no_decimals: () => formatWithDelimiters(value, 0, ",", "."),
            amount_with_comma_separator: () => formatWithDelimiters(value, 2, ".", ","),
            amount_no_decimals_with_comma_separator: () => formatWithDelimiters(value, 0, ".", ","),
        };

        const match = String(moneyFormat).match(
            /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/
        );

        if (!match) return (value / 100).toFixed(2);

        const token = match[1];
        const formatted = tokenMap[token] ? tokenMap[token]() : (value / 100).toFixed(2);

        return String(moneyFormat).replace(match[0], formatted);
    }

    // --- Wire up ---
    document.addEventListener("DOMContentLoaded", () => init());
    document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
